import { produce } from 'immer'
import { State } from '../typings'
import { ServiceLocation } from '@user/store/entityLocations'

export type LoadRelatedAction = {
  type: 'loadRelated'
  payload: ServiceLocation[]
}

type LoadRelatedActionCreator = (
  payload: LoadRelatedAction['payload'],
) => LoadRelatedAction

export const loadRelated = produce<State, [LoadRelatedAction['payload']]>(
  (draft, payload) => {
    draft.loading = false
    draft.serviceLocations = payload
  },
)

export const loadRelatedActionCreator: LoadRelatedActionCreator = (
  payload,
) => ({
  type: 'loadRelated',
  payload,
})
